import BestGames from "./BestGames";
import OurGame from "./OurGame";
import EarnNow from "./EarnNow";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { verifyEmailApi } from "@/services/api.service";
import RestDialog from "../Login/PasswordReset/ResetDialog";
import StatusDialog from "@/components/dialogs/StatusDialog";
import { toast } from "react-toastify";
import LoginSuccessStatusDialog from "@/components/dialogs/LoginSuccessStatusDialog";
import Cookies from "js-cookie";
import { config } from "@/config";
import HomeCarousel from "@/components/cards/home/HomeCarousel";
import useUserStore from "@/stores/authentication/store";
import Bets from "../Lobby/components/Bets";
import SharkCoinIcon from "@/icons/withdraw/coins/sharkCoinIcon";
import { getCdnUrl } from "@/lib/utils";
import { intervalToDuration } from "date-fns";
import { useMobileDetect } from "@/hooks";
import PreviewBanner from "@/components/cards/home/PreviewBanner.tsx";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showResetDialog, setShowResetDialog] = useState(false);
  const [resetEmail, setResetEmail] = useState("abc@gmail.com");
  const [resetToken, setResetToken] = useState("");
  const [showVerifyModal, setShowVerifyModal] = useState<boolean>(false);
  const { isAuthenticated } = useUserStore();

  const [searchParams] = useSearchParams();
  const previewBanner = searchParams.get("previewBanner") === "true";

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const method = queryParams.get("method");
    const email = queryParams.get("email");
    const refCode = queryParams.get("refCode");
    console.log("refCode : ", refCode);

    if (refCode) {
      Cookies.set("refCode", refCode, {
        httpOnly: false,
        expires: 1, // Cookie will expire in 7 days
        path: "/", // Cookie will be available across the entire domain
        domain:
          config.env !== "development"
            ? config.cookie.cookieDomain
            : "localhost", // Specify your domain
        secure: config.env !== "development", // Cookie will only be sent over HTTPS
        sameSite: config.env !== "development" ? "lax" : "lax", // Cookie will only be sent in a first-party context
      });
    }

    if (token && method) {
      switch (method) {
        case "registration":
          verifyEmailApi
            .post(`/auth/local/email-verify?verifyToken=${token}`)
            .then((response) => {
              if (response.status === 200) {
                setShowVerifyModal(true);
                navigate("/");
              }
            })
            .catch((error) => {
              toast.error("Verification failed. " + error.response.data.error);
            });
          break;

        case "forgetpassword":
          setResetEmail(email ? email : "");
          setResetToken(token);
          setShowResetDialog(true);
          break;

        default:
          // Handle other methods or do nothing
          break;
      }
    }
  }, [location, navigate]);
  return (
    <div>
      <PreviewBanner inPreview={previewBanner} />
      <div className={`w-full space-y-4 overflow-x-clip lg:py-16`}>
        {/* <TgeCountdown /> */}
        <HomeCarousel inPreview={previewBanner} />
        <OurGame />
        <BestGames />
        <EarnNow />
        <Bets hideTabs={true} />
        {showResetDialog && (
          <RestDialog
            isOpen={showResetDialog}
            email={resetEmail}
            token={resetToken}
            onClose={() => setShowResetDialog(false)}
          />
        )}
        <StatusDialog
          status="success"
          onClose={() => setShowVerifyModal(false)}
          title="Successful!"
          message={
            <>
              Your account is verified!
              <br />
              You can log in to your account now.
            </>
          }
          buttonText="Close"
          isOpen={showVerifyModal}
          setIsOpen={() => setShowVerifyModal(false)}
        />

        {isAuthenticated && <LoginSuccessStatusDialog />}
      </div>
    </div>
  );
};

const TgeCountdown = () => {
  const [remainingTime, setRemainingTime] = useState(
    intervalToDuration({
      start: new Date(),
      end: new Date(2025, 3, 31),
    }),
  );

  const isMobile = useMobileDetect();

  useEffect(() => {
    const targetDate = new Date(2025, 3, 31);

    const interval = setInterval(() => {
      const duration = intervalToDuration({
        start: new Date(),
        end: targetDate,
      });
      setRemainingTime(duration);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex h-[83px] w-full items-center justify-center gap-8 bg-gradient-to-r from-[#0842B0]/0 via-[#0842B0] to-[#0842B0]/0 text-white md:gap-4">
      <div className="flex flex-col gap-2 md:flex-row">
        <div className="flex items-center gap-2">
          <SharkCoinIcon
            width={isMobile ? 22 : 36}
            height={isMobile ? 22 : 36}
          />
          <div className="text-[12px] font-[500] md:text-xl">
            $SHRL TOKEN TGE:
          </div>
        </div>
        <div className="rounded-lg bg-secondary text-center text-[16px] font-[500] md:p-2 md:px-4 md:text-xl">
          31.03. 2025
        </div>
      </div>
      <div className="relative">
        <img
          className="h-[50px] md:h-[68px]"
          src={getCdnUrl("assets/home/countdown.png")}
          alt="countdown"
        />
        <div className="absolute left-[10.5px] top-[11px] flex flex-col items-center justify-center gap-[3px] leading-none md:left-[16px] md:top-[18px]">
          <div className="text-[17px] font-[500] md:text-[21px]">
            {remainingTime.days ?? "00"}
          </div>
          <div className="text-[12px] text-[9px] font-[500]">Days</div>
        </div>
        <div className="absolute left-[49.5px] top-[11px] flex flex-col items-center justify-center gap-[3px] leading-none md:left-[72px] md:top-[18px]">
          <div className="text-[17px] font-[500] md:text-[21px]">
            {remainingTime.hours ?? "00"}
          </div>
          <div className="text-[12px] text-[9px] font-[500]">Hours</div>
        </div>
        <div className="absolute right-[77px] top-[11px] flex flex-col items-center justify-center gap-[3px] leading-none md:right-[106px] md:top-[18px]">
          <div className="text-[17px] font-[500] md:text-[21px]">
            {remainingTime.minutes ?? "00"}
          </div>
          <div className="text-[12px] text-[9px] font-[500]">Min</div>
        </div>
        <div className="absolute right-[35px] top-[11px] flex flex-col items-center justify-center gap-[3px] leading-none md:right-[50px] md:top-[18px]">
          <div className="text-[17px] font-[500] md:text-[21px]">
            {remainingTime.seconds?.toString().padStart(2, "0") ?? "00"}
          </div>
          <div className="text-[12px] text-[9px] font-[500]">Sec</div>
        </div>
      </div>
    </div>
  );
};

export default Home;
